// Internal
import { ColorPicker } from "../color-picker/color-picker";
import { FormInput } from "./form-input";
import { FormSkeleton } from "./form-skeleton";

function FormColor(props) {
    const changeHandler = (value) => {
        if (typeof props.OnChange === "function") {
            props.OnChange(value);
        }
    };

    if (props.Visible !== undefined && !props.Visible) {
        return null;
    }

    if (props.Skeleton) {
        return (
            <FormSkeleton
                Label={props.Label}
                DataTestId={props.DataTestId} />
        )
    }

    return (
        <FormInput
            Id={props.Id}
            Label={props.Label}
            ShowRequiredIndicator={props.ShowRequiredIndicator}
            RequiredStringIndicator={props.RequiredStringIndicator}
            Class={props.Class}
            Style={props.Style}
            Info={props.Info}
            Width={props.Width}
            Buttons={props.Buttons}
            DataTestId={props.DataTestId}
            HelpLink={props.HelpLink}
            Tooltip={props.Tooltip}
            TooltipTitle={props.TooltipTitle}
            TooltipWidth={props.TooltipWidth} >
            <ColorPicker
                Id={props.Id}
                ReadOnly={props.ReadOnly}
                Value={props.Value}
                AutoFocus={props.AutoFocus}
                OnChange={changeHandler}
                OnUpdate={props.OnUpdate}
                DataTestId={props.DataTestId} />
        </FormInput>
    );
}

export { FormColor };
